

const backToTopBtn = document.querySelector('#back-to-top');
const offset = window.innerHeight;

// When the user scrolls down 20px from the top of the document, show the button
backToTopBtn.toggleClass = function () {
    if (document.body.scrollTop > offset || document.documentElement.scrollTop > offset) {
        backToTopBtn.classList.add('active');
    }
    else {
        backToTopBtn.classList.remove('active');
    }
};

// init on DOMContentLoaded
document.addEventListener('DOMContentLoaded', function (e) {
    backToTopBtn.toggleClass();
});

// init on scroll
window.onscroll = function () { backToTopBtn.toggleClass() };

// back to top on click
backToTopBtn.addEventListener('click', function () {
    document.body.scrollIntoView({
        behavior: 'smooth',
    });
});